import { createFileRoute } from "@tanstack/react-router";

import { InhaltePflege } from "@/components/inhalte-pflege";

function CoachInhaltePage() {
  return <InhaltePflege />;
}

export const Route = createFileRoute("/_app/coach/inhalte")({
  component: CoachInhaltePage,
});
